import { useLocalStorage } from "./localStorage";
import { Device } from "@capacitor/device";
import httpApp from "./http";
import { useCustomerStore } from "@/stores/customer";
import { useMainStore } from "@/stores/main";
const { setLocalStorageData, getLocalStorageData } = useLocalStorage();
//const storeX = useStore();
// const domainLangUrl = window.location.origin;
//const develop = domainLangUrl.includes("localhost");
const develop = true;
const settingsApp = {
	getEndpointUrl: (url: any) => {
		let fullUrl;
		if (develop) {
			fullUrl = getLocalStorageData("websiteUrl");
		} else {
			fullUrl = getLocalStorageData("apiUrl");
		}
		fullUrl += getLocalStorageData("urls")[url];
		return fullUrl;
	},

	setDefaultSettings: async () => {
		const deviceLanguage = await Device.getLanguageCode();
		new Promise((resolve) => {
			let languageCode = getLocalStorageData("storeCode");
			if (!languageCode) {
				if (deviceLanguage.value.includes("-")) {
					const languageAr = deviceLanguage.value.split("-");
					languageCode = languageAr[0];
				} else {
					languageCode = deviceLanguage.value;
				}

				if (!languageCode) {
					languageCode = "en";
				}
			}
			const settingsDarkMode = getLocalStorageData("darkMode");
			if (settingsDarkMode) {
				//document.body.classList.toggle("dark", true);
			}
			const websiteUrl = "https://be.dishcoveruk.com/";
			//const fullUrl = "https://dishcoveruk.com:37973/";
			const fullUrl = "https://be.dishcoveruk.com/";
			const apiKey =
					"IakPALvh5mI0nifqvEmkiuEBKqxCJ2oBf9OJ7G4v2r8xtra11la2aFzJcH3DtNxPcnlBJPAIsfE8p2wxNODi5MNMLmpy0Hcmft0K",
				apiCode = "DMvKAPkonlH79MnIq8uJ";

			setLocalStorageData({
				apiUrl: fullUrl,
				websiteUrl: websiteUrl,
				apiKey: apiKey,
				apiCode: apiCode,
				postcodeApi: "",
				appManagerCode: "ptm_pwa",
				urls: {
					getToken: "restfulapi/getPwaToken",
					getStores: "restfulapi/core/websites/getAllStores",
					setStore: "restfulapi/core/websites/setCurrentStore",
					getCurrencies:
						"restfulapi/core/websites/getCurrentStoreCurrencies",
					setCurrency: "restfulapi/core/websites/setCurrentCurrency",
					parseUrlKey: "restfulapi/core/websites/parseUrlKey",
					getConfigs: "restfulapi/core/config/getConfigByPaths",
					getConfig: "restfulapi/core/config/getConfigByPath",
					isLoggedIn: "restfulapi/core/customers/checkLoginSession",
					login: "restfulapi/core/customers/login",
					logout: "restfulapi/core/customers/customerLogout",
					register: "restfulapi/core/customers/createAccount",
					getLoginCustomerData:
						"restfulapi/core/customers/getLoginCustomerData",
					forgotPassword: "restfulapi/core/customers/forgotPassword",
					confirmAccount: "restfulapi/core/customers/confirmAccount",
					validateForgotPasswordToken:
						"restfulapi/core/customers/validateForgotPasswordToken",
					changeForgottenPassword:
						"restfulapi/core/customers/changeForgottenPassword",
					getAllAddresses:
						"restfulapi/core/customers/getCustomerAllAddresses",
					getDefaultAddresses:
						"restfulapi/core/customers/getDefaultAddresses",
					addAddress: "restfulapi/core/customers/addAddress",
					editAddress: "restfulapi/core/customers/editAddress",
					deleteAddress: "restfulapi/core/customers/deleteAddress",
					getAddress: "restfulapi/core/customers/getAddressbyId",
					editCustomer: "restfulapi/core/customers/editCustomer",
					getOrders: "restfulapi/core/customers/getOrders",
					getOrder: "restfulapi/core/customers/getOrder",
					cancelOrder: "restfulapi/core/customers/cancelOrder",
					getWishlistItems:
						"restfulapi/core/customers/getWishlistItems",
					addWishlistItem:
						"restfulapi/core/customers/addWishlistItem",
					deleteWishlistItem:
						"restfulapi/core/customers/deleteWishlistItem",
					productsList: "restfulapi/core/products/getlist",
					productsListByCategory:
						"restfulapi/core/products/getByCategory",
					productsListByCategoryAndFilters:
						"restfulapi/core/products/getByCategoryAndFilters",
					productsListByAttribute:
						"restfulapi/core/products/getByAttribute",
					getProductsByType:
						"restfulapi/core/products/getProductsByType",
					getNewProducts: "restfulapi/core/products/getNewProducts",
					getBestSellerProducts:
						"restfulapi/core/products/getBestSellerProducts",
					getTopRatedProducts:
						"restfulapi/core/products/getTopRatedProducts",
					productById: "restfulapi/core/products/getItem",
					getproductsothersellers:
						"restfulapi/epowermarketplace/vendor/getproductsothersellers",
					vendorGetdata:
						"restfulapi/epowermarketplace/vendor/getdata",
					vendorGetproducts:
						"restfulapi/epowermarketplace/vendor/getproducts",
					getVendorById:
						"restfulapi/epowermarketplace/vendor/getVendorById",
					getSellerLayerNav:
						"restfulapi/epowermarketplace/vendor/getSellerLayerNav",
					catalogSearch: "restfulapi/core/catalogsearch/search",
					notifyStock: "restfulapi/core/products/notifyStock",
					getAvailableListSorting:
						"restfulapi/core/products/getAvailableListSorting",
					getLayredNavAttributes:
						"restfulapi/core/products/getLayredNavAttributes",
					searchProductsByName:
						"restfulapi/core/products/searchProductsByName",
					getProductsReviews:
						"restfulapi/core/products/getProductsReviews",
					cusstomProductReviews:
						"restfulapi/epowermarketplace/product/getProductReviews",
					getProductsReviewRatings:
						"restfulapi/core/products/getProductsReviewRatings",
					addProductReview:
						"restfulapi/core/products/addProductReview",
					categoryTree: "restfulapi/core/categories/getTree",
					categoryByLevel: "restfulapi/core/categories/getByLevel",
					categorySubById: "restfulapi/core/categories/getSubById",
					categoryById: "restfulapi/core/categories/getById",
					addToCart: "restfulapi/core/cart/addToCart",
					updateQuantity: "restfulapi/core/cart/updateQuantity",
					updateQuantityById:
						"restfulapi/core/cart/updateQuantityById",
					getQuote: "restfulapi/core/cart/getCurrentQuote",
					getQuoteItems: "restfulapi/core/cart/getQuoteItems",
					removeItemCart: "restfulapi/core/cart/removeItem",
					removeItemCartById: "restfulapi/core/cart/removeItemById",
					removeItemsCart: "restfulapi/core/cart/removeItems",
					updateItemsCart:
						"restfulapi/core/cart/updateCartQuantities",
					applyPromoCode: "restfulapi/core/cart/applyPromoCode",
					reorder: "restfulapi/core/cart/reorder",
					getStatesByCountry:
						"restfulapi/core/geodata/getStatesByCountry",
					getCitiesByState: "restfulapi/core/geodata/getCityByState",
					saveBillingAddress:
						"restfulapi/core/checkout/saveBillingAddress",
					getPaymentMethods:
						"restfulapi/core/checkout/getAvailablePaymentMethods",
					setPaymentMethod:
						"restfulapi/core/checkout/setPaymentMethod",
					getShipingMethods:
						"restfulapi/core/checkout/getAvailableShippingRates",
					setShipingRate: "restfulapi/core/checkout/setShipingRate",
					placeOrder: "restfulapi/core/checkout/placeOrder",
					mpgsConfiguration:
						"restfulapi/mpgshc/payment/getJsConfigurations",
					mpgsValidatePayment:
						"restfulapi/mpgshc/payment/validatePayment",
					mpgsCancelPayment:
						"restfulapi/mpgshc/payment/cancelPayment",
					sendContactMessage: "restfulapi/core/contact/postForm",
					cmsPage: "restfulapi/core/cms/getPage",
					cmsBlock: "restfulapi/core/cms/getBlock",
					cmsBlocks: "restfulapi/core/cms/getBlocks",
					getSimpleBlock: "restfulapi/core/cms/getSimpleBlock",
					getSimpleBlocks: "restfulapi/core/cms/getSimpleBlocks",
					getApp: "restfulapi/appmanagerapi/app/getApp",
					deviceAdd: "restfulapi/appmanagerapi/device/add",
					getSlider: "restfulapi/appmanagerapi/slider/getSlider",
					getBanner: "restfulapi/appmanagerapi/banner/getBanner",
					getNotifications:
						"restfulapi/appmanagerapi/notification/getNotifications",
					getNewNotificationsCount:
						"restfulapi/appmanagerapi/notification/getNewNotificationsCount",
					markAllNotificationsAsRead:
						"restfulapi/appmanagerapi/notification/markAllNotificationsAsRead",
					markAllNotificationsAsDeleted:
						"restfulapi/appmanagerapi/notification/markAllNotificationsAsDeleted",
					markNotificationAsRead:
						"restfulapi/appmanagerapi/notification/markAsRead",
					markNotificationAsDeleted:
						"restfulapi/appmanagerapi/notification/markAsDeleted",
					getMenu: "restfulapi/customization/menu/getMenu",
					getMenus: "restfulapi/customization/menu/getMenus",
					getFAQ: "restfulapi/customization/faq/getFaqByCode",
					getSellerShippingType:
						"restfulapi/customization/shippingtype/getSellerShippingType",
					getRegionalFoodList:
						"restfulapi/customization/preferences/getRegionalFood",
					getDietaryPreferenceList:
						"restfulapi/customization/preferences/getDietaryPreferenceList",
					getDeliveryDates:
						"restfulapi/customization/preferences/getDeliveryDates",
					getDishCategories:
						"restfulapi/customization/preferences/getDishCategories",
					getCustomerFollowedSellersIds:
						"restfulapi/customization/customer/getCustomerFollowedSellersIds",
					getCustomerFollowedSellers:
						"restfulapi/customization/customer/getCustomerFollowedSellers",
					addSellerFollow:
						"restfulapi/customization/customer/addSellerFollow",
					removeSellerFollow:
						"restfulapi/customization/customer/removeSellerFollow",
					setSearchedPostcode:
						"restfulapi/customization/cart/setSearchedPostcode",
					isSubscribedNewsletter:
						"restfulapi/core/newsletters/isSubscribed",
					subscribeNewsletter:
						"restfulapi/core/newsletters/subscribe",
					unsubscribeNewsletter:
						"restfulapi/core/newsletters/unsubscribe",
					addProductToCompare:
						"restfulapi/core/products/addProductToCompare",
					getProductToCompare:
						"restfulapi/core/products/getProductToCompare",
					removeProductFromCompare:
						"restfulapi/core/products/removeProductFromCompare",
					clearCompare: "restfulapi/core/products/clearCompare",
					getSellerFormData:
						"restfulapi/epowermarketplace/seller/getSellerFormData",
					saveVendor:
						"restfulapi/epowermarketplace/seller/saveVendor",
					getvendorStatesByCountry:
						"restfulapi/core/geodata/getStatesByCountry",
					getVendorByRegion:
						"restfulapi/epowermarketplace/vendor/getVendorByRegion",
					sellerGetProductTemplates:
						"restfulapi/epowermarketplace/seller/gettemplates",
					sellerGetProductTemplateData:
						"restfulapi/epowermarketplace/seller/getTemplateEditableData",
					sellerGetProductProductData:
						"restfulapi/epowermarketplace/seller/getProductEditableData",
					sellerSaveProductData:
						"restfulapi/epowermarketplace/seller/createrequest",
					deleteSellerProduct:
						"restfulapi/epowermarketplace/seller/deleteSellerProduct",
					sellerGetproducts:
						"restfulapi/epowermarketplace/seller/getproducts",
					getSellerCommissions:
						"restfulapi/epowermarketplace/seller/getSellerCommissions",
					getSellerCashBack:
						"restfulapi/epowermarketplace/seller/getSellerCashBack",
					getSellerPendingOrders:
						"restfulapi/epowermarketplace/seller/getSellerPendingOrders",
					getSellerPastOrders:
						"restfulapi/epowermarketplace/seller/getSellerPastOrders",
					addBuyerReview:
						"restfulapi/epowermarketplace/seller/addBuyerReview",
					getBuyerReview:
						"restfulapi/epowermarketplace/seller/getBuyerReviews",
					getSellerOrderDetails:
						"restfulapi/epowermarketplace/seller/getSellerOrderDetails",
					getCustomerPriceGroups:
						"restfulapi/epowermarketplace/seller/getCustomerGroups",
					getProductEditableData:
						"restfulapi/epowermarketplace/seller/getProductEditableData",
					saveProductEditablePrice:
						"restfulapi/epowermarketplace/seller/saveProductPrice",
					saveProductEditableInventory:
						"restfulapi/epowermarketplace/seller/saveProductInventory",
					getSellerOrderDataBySalesItem:
						"restfulapi/epowermarketplace/customer/getSellerOrderDataBySalesItem",
					getSalesterms: "restfulapi/core/terms/getterms",
					getSellersList:
						"restfulapi/epowermarketplace/seller/getSellersList",
					getTestimonialByType:
						"restfulapi/customization/testimonial/getTestimonialByType",
					getProductMaxQty:
						"restfulapi/customization/inventory/getProductMaxQty",
					getSellerExceptionRuleTypes:
						"restfulapi/customization/sellerexceptionrule/getSellerExceptionRuleTypes",
					getSellerExceptionRules:
						"restfulapi/customization/sellerexceptionrule/getSellerExceptionRules",
					addSellerExceptionRule:
						"restfulapi/customization/sellerexceptionrule/addSellerExceptionRule",
					editSellerExceptionRule:
						"restfulapi/customization/sellerexceptionrule/editSellerExceptionRule",
					deleteSellerExceptionRule:
						"restfulapi/customization/sellerexceptionrule/deleteSellerExceptionRule",
					saveScheduleData:
						"restfulapi/customization/sellerexceptionrule/saveScheduleData",
					stripeIsConnected:
						"restfulapi/epowerstripe/connect/isConnected",
					stripeGetAccount:
						"restfulapi/epowerstripe/connect/getAccount",
					updatePaymentIntent:
						"restfulapi/epowerstripe/payment/updatePaymentIntent",
					getPaymentClientSecret:
						"restfulapi/epowerstripe/payment/getPaymentClientSecret",
					handleStripeOrderByPaymentIntent:
						"restfulapi/epowerstripe/payment/handleStripeOrderByPaymentIntent",
					getsellersindistancerange:
						"restfulapi/customization/platters/getsellersindistancerange",
					getCookerOrdersInPeriod:
						"restfulapi/customization/cooker/getCookerOrdersInPeriod",
					addSellerRequest:
						"restfulapi/customization/cooker/addSellerRequest",
					sellerListCount:
						"restfulapi/customization/count/sellerList",
					matchedCooksPlatter:
						"restfulapi/customization/count/matchedCooksPlatter",
					getTotalSalesInPeriod:
						"restfulapi/customization/insights/getTotalSalesInPeriod",
					getNetSalesInPeriod:
						"restfulapi/customization/insights/getNetSalesInPeriod",
					getOrdersInPeriod:
						"restfulapi/customization/insights/getOrdersInPeriod",
					getDishesSoldInPeriod:
						"restfulapi/customization/insights/getDishesSoldInPeriod",
					getMostPopularDishesInPeriod:
						"restfulapi/customization/insights/getMostPopularDishesInPeriod",
					getMostPopularCategoriesInPeriod:
						"restfulapi/customization/insights/getMostPopularCategoriesInPeriod",
					setOrderAction:
						"restfulapi/customization/cooker/setOrderAction",
					getCustomersTransfers:
						"restfulapi/epowerstripe/transfer/getCustomersTransfers",
					postGetList: "restfulapi/blog/post/getList",
					postGetItem: "restfulapi/blog/post/getItem",
					postGetComments: "restfulapi/blog/post/getComments",
					postAddComment: "restfulapi/blog/post/addComment",
					categoriesGetList: "restfulapi/blog/categories/getList",
					categoriesGetItem: "restfulapi/blog/categories/getItem",
					tagGetList: "restfulapi/blog/tag/getList",
					getCustomSlider:
						"restfulapi/customization/slider/getSlider",
				},
			});
			resolve(true);
		});
	},

	getWebsiteSettings: () => {
		const configsPromise = new Promise((resolve) => {
			const paths = [
				"sales/minimum_order/amount",
				"general/store_information/phone",
				"trans_email/ident_support/email",
				"persistent/options/enabled",
				"persistent/options/lifetime",
				"persistent/options/remember_enabled",
				"persistent/options/remember_default",
				"customer/address/map_service",
				"customer/address/google_api_key",
				"general/country/default",
				"general/country/allow",
				"customization_postcode/postcode_api/api_url",
				"customization_ordering/ordering_options/last_hour",
				"customization_general/products_options/dish_template",
				"customization_general/products_options/lunchbox_template",
				"payment/egyprotech_epowerstripe/active",
				"payment/egyprotech_epowerstripe/payment_checkout_type",
				"payment/egyprotech_epowerstripe/stripe_js",
				"epowerstripe_api/standard_keys/publishable_key",
				"blog/comments/enabled",
				"blog/comments/login",
			];
			httpApp
				.sendPostRequest(settingsApp.getEndpointUrl("getConfigs"), {
					paths: paths.join(","),
				})
				.then((response: any) => {
					const minimumAmount =
						response["sales/minimum_order/amount"];
					if (minimumAmount) {
						if (
							!Object.prototype.hasOwnProperty.call(
								minimumAmount,
								"error"
							)
						) {
							setLocalStorageData({
								minimumAmount: minimumAmount,
							});
						}
					}
					const storeInformationPhone =
						response["general/store_information/phone"];
					if (storeInformationPhone) {
						if (
							!Object.prototype.hasOwnProperty.call(
								storeInformationPhone,
								"error"
							)
						) {
							setLocalStorageData({
								storeInformationPhone: storeInformationPhone,
							});
						}
					}
					const customerSupportEmail =
						response["trans_email/ident_support/email"];
					if (customerSupportEmail) {
						if (
							!Object.prototype.hasOwnProperty.call(
								customerSupportEmail,
								"error"
							)
						) {
							setLocalStorageData({
								customerSupportEmail: customerSupportEmail,
							});
						}
					}
					const persistentEnabled =
						response["persistent/options/enabled"];
					if (persistentEnabled) {
						if (
							!Object.prototype.hasOwnProperty.call(
								persistentEnabled,
								"error"
							)
						) {
							setLocalStorageData({
								persistentEnabled: persistentEnabled,
							});
						}
					}
					const persistentLifetime =
						response["persistent/options/lifetime"];
					if (persistentLifetime) {
						if (
							!Object.prototype.hasOwnProperty.call(
								persistentLifetime,
								"error"
							)
						) {
							setLocalStorageData({
								persistentLifetime: persistentLifetime,
							});
						}
					}
					const persistentRememberEnabled =
						response["persistent/options/remember_enabled"];
					if (persistentRememberEnabled) {
						if (
							!Object.prototype.hasOwnProperty.call(
								persistentRememberEnabled,
								"error"
							)
						) {
							setLocalStorageData({
								persistentRememberEnabled:
									persistentRememberEnabled,
							});
						}
					}
					const persistentRememberDefault =
						response["persistent/options/remember_default"];
					if (persistentRememberEnabled) {
						if (
							!Object.prototype.hasOwnProperty.call(
								persistentRememberEnabled,
								"error"
							)
						) {
							setLocalStorageData({
								persistentRememberDefault:
									persistentRememberDefault,
							});
						}
					}
					const mapService = response["customer/address/map_service"];
					if (mapService) {
						if (
							!Object.prototype.hasOwnProperty.call(
								mapService,
								"error"
							)
						) {
							setLocalStorageData({
								mapService: mapService,
							});
						}
					}
					const reviewAllowGuest =
						response["catalog/review/allow_guest"];
					if (reviewAllowGuest) {
						if (
							!Object.prototype.hasOwnProperty.call(
								reviewAllowGuest,
								"error"
							)
						) {
							setLocalStorageData({
								reviewAllowGuest: reviewAllowGuest,
							});
						}
					}
					const allowedCountries = response["general/country/allow"];
					if (allowedCountries) {
						if (
							!Object.prototype.hasOwnProperty.call(
								allowedCountries,
								"error"
							)
						) {
							setLocalStorageData({
								allowedCountries: allowedCountries,
							});
						}
					}
					const defaultCountry = response["general/country/default"];
					if (defaultCountry) {
						if (
							!Object.prototype.hasOwnProperty.call(
								defaultCountry,
								"error"
							)
						) {
							setLocalStorageData({
								defaultCountry: defaultCountry,
							});
						}
					}
					const postCodeAPI =
						response["customization_postcode/postcode_api/api_url"];
					if (postCodeAPI) {
						if (
							!Object.prototype.hasOwnProperty.call(
								postCodeAPI,
								"error"
							)
						) {
							setLocalStorageData({
								postcodeApi: postCodeAPI,
							});
						}
					}

					const lastHourNextDayDelivery =
						response[
							"customization_ordering/ordering_options/last_hour"
						];
					if (lastHourNextDayDelivery) {
						if (
							!Object.prototype.hasOwnProperty.call(
								lastHourNextDayDelivery,
								"error"
							)
						) {
							setLocalStorageData({
								lastHourNextDayDelivery:
									lastHourNextDayDelivery,
							});
						}
					}

					const dishTemplate =
						response[
							"customization_general/products_options/dish_template"
						];
					if (dishTemplate) {
						if (
							!Object.prototype.hasOwnProperty.call(
								dishTemplate,
								"error"
							)
						) {
							setLocalStorageData({
								dishTemplate: dishTemplate,
							});
						}
					}

					const lunchboxTemplate =
						response[
							"customization_general/products_options/lunchbox_template"
						];
					if (lunchboxTemplate) {
						if (
							!Object.prototype.hasOwnProperty.call(
								lunchboxTemplate,
								"error"
							)
						) {
							setLocalStorageData({
								lunchboxTemplate: lunchboxTemplate,
							});
						}
					}

					const stripeMethodActive =
						response["payment/egyprotech_epowerstripe/active"];
					if (stripeMethodActive) {
						if (
							!Object.prototype.hasOwnProperty.call(
								stripeMethodActive,
								"error"
							)
						) {
							setLocalStorageData({
								stripeMethodActive: stripeMethodActive,
							});
						}
					}

					const stripePaymentCheckoutType =
						response[
							"payment/egyprotech_epowerstripe/payment_checkout_type"
						];
					if (stripePaymentCheckoutType) {
						if (
							!Object.prototype.hasOwnProperty.call(
								stripePaymentCheckoutType,
								"error"
							)
						) {
							setLocalStorageData({
								stripePaymentCheckoutType:
									stripePaymentCheckoutType,
							});
						}
					}

					const stripeJsUrl =
						response["payment/egyprotech_epowerstripe/stripe_js"];
					if (stripeJsUrl) {
						if (
							!Object.prototype.hasOwnProperty.call(
								stripeJsUrl,
								"error"
							)
						) {
							setLocalStorageData({
								stripeJsUrl: stripeJsUrl,
							});
						}
					}

					const stripePublishableKey =
						response[
							"epowerstripe_api/standard_keys/publishable_key"
						];
					if (stripePublishableKey) {
						if (
							!Object.prototype.hasOwnProperty.call(
								stripePublishableKey,
								"error"
							)
						) {
							setLocalStorageData({
								stripePublishableKey: stripePublishableKey,
							});
						}
					}
					const blogEnableComments =
						response["blog/comments/enabled"];
					if (blogEnableComments) {
						if (
							!Object.prototype.hasOwnProperty.call(
								stripeJsUrl,
								"error"
							)
						) {
							setLocalStorageData({
								blogEnableComments: blogEnableComments,
							});
						}
					}
					const loginRequiredToComment =
						response["blog/comments/login"];
					if (loginRequiredToComment) {
						if (
							!Object.prototype.hasOwnProperty.call(
								stripeJsUrl,
								"error"
							)
						) {
							setLocalStorageData({
								loginRequiredToComment: loginRequiredToComment,
							});
						}
					}
					resolve(true);
				})
				.catch((error) => {
					if (error.status == 403) {
						if (
							Object.prototype.hasOwnProperty.call(error, "error")
						) {
							const data = JSON.parse(error.error);
							if (data.error.code == "304") {
								setLocalStorageData({
									apiUrl: null,
									apiKey: null,
									apiCode: null,
								});
							}
						}
					}
					console.log("getConfigs", error);
				});
		});

		const mainStore = useMainStore();
		new Promise((resolve, reject) => {
			httpApp
				.sendGetRequest(settingsApp.getEndpointUrl("getStores"))
				.then((response: any) => {
					if (response.items) {
						const stores: any = [];
						let baseStore: any;
						response.items.forEach(function (
							storeview: any,
							i: number
						) {
							if (
								storeview.is_active == "1" &&
								storeview.website_id == "1"
							) {
								stores.push({
									code: storeview.code,
									name: storeview.name,
								});
								if (!getLocalStorageData("storeCode")) {
									setLocalStorageData({
										storeCode: storeview.code,
									});
									mainStore.setStoreCode(storeview.code);
								}
								baseStore = storeview;
							}
							if (response.items.length == i + 1) {
								setLocalStorageData({
									stores: stores,
								});
								resolve({
									stores,
									baseStore,
								});
							}
						});
					} else {
						reject(response.data);
					}
				})
				.catch((error) => {
					reject(error);
					console.log("getStores", error);
				});
		});

		new Promise((resolve, reject) => {
			httpApp
				.sendGetRequest(settingsApp.getEndpointUrl("getCurrencies"))
				.then((response: any) => {
					if (response.items) {
						const currencies: any = [];
						const currentCurrency = getLocalStorageData("currency");
						let currentCurrencyExist = false;
						let baseCurrency: any = null;
						response.items.forEach(function (
							currency: any,
							i: number
						) {
							currencies.push({
								code: currency.code,
								name: currency.name,
							});
							if (
								!getLocalStorageData("currency") &&
								currency.is_base
							) {
								setLocalStorageData({
									currency: currency.code,
								});
							}
							if (currency.code == currentCurrency) {
								currentCurrencyExist = true;
							}
							if (currency.is_base) {
								baseCurrency = currency.code;
							}
							if (response.items.length == i + 1) {
								setLocalStorageData({
									currencies: currencies,
								});
								if (!currentCurrencyExist) {
									setLocalStorageData({
										currency: baseCurrency,
									});
								}
								resolve({ currencies, baseCurrency });
							}
						});
					} else {
						resolve(true);
					}
				})
				.catch((error) => {
					reject(error);
					console.log("getCurrencies", error);
				});
		});

		new Promise((resolve, reject) => {
			httpApp
				.sendPostRequest(
					settingsApp.getEndpointUrl("getStatesByCountry"),
					{
						country_id: "GB",
					}
				)
				.then(async (response: any) => {
					if (
						!Object.prototype.hasOwnProperty.call(response, "error")
					) {
						setLocalStorageData({
							gBStates: response.items,
						});
						mainStore.setgBStates(response.items);
						resolve(response.items);
					}
				})
				.catch((error) => {
					reject(error);
				});
		});

		return Promise.all([configsPromise]);
	},

	setStoreToSession: (storeCode: string) => {
		return new Promise(function (resolve, reject) {
			httpApp
				.sendPostRequest(settingsApp.getEndpointUrl("setStore"), {
					store_code: storeCode,
				})
				.then((response: any) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
					console.log("setStore", error);
				});
		});
	},

	getVendorData: () => {
		const mainStore = useMainStore();
		const customerStore = useCustomerStore();
		return new Promise((resolve, reject) => {
			httpApp
				.sendPostRequest(
					settingsApp.getEndpointUrl("getSellerFormData"),
					{
						store_view: mainStore.storeCode,
					}
				)
				.then(async (response: any) => {
					const resp = response;
					if (resp.success) {
						setLocalStorageData({
							sellerData: resp,
						});
						customerStore.setSellerData(resp);
						resolve(true);
					} else {
						setLocalStorageData({
							sellerData: null,
						});
						customerStore.setSellerData(null);
						reject(true);
					}
				})
				.catch((error) => {
					console.log(error, "error");
				});
		});
	},

	setPwaToken: async () => {
		const mainStore = useMainStore();
		let pwaDone;
		if (develop) {
			return true;
		}
		try {
			const response = await fetch(
				settingsApp.getEndpointUrl("getToken"),
				{
					credentials: "include",
					method: "GET",
				}
			);
			const returnData = await response.json();
			if (returnData["Pwa-Code"] && returnData["Pwa-Token"]) {
				mainStore.setPwaTokenCode(
					returnData["Pwa-Token"],
					returnData["Pwa-Code"]
				);
				pwaDone = true;
			}
		} catch (error) {
			console.log(error);
			pwaDone = false;
		}
		return pwaDone;
	},

	initialize: async () => {
		await settingsApp.setDefaultSettings();
		//settingsApp.getVendorData();
		// Get PWA Token
		await settingsApp.setPwaToken();
		return new Promise((resolve, reject) => {
			settingsApp.getWebsiteSettings().then(
				(responses) => {
					resolve(responses);
				},
				() => {
					reject();
				}
			);
		});
	},
};

export default settingsApp;
